<template>
 <v-list nav v-if="largeScreen" color="transparent" class="px-0 ml-15" width="300">
         

      <v-list-item-group v-model="type" 
        mandatory>
        <v-list-item
         v-for="(menu, i) in menus"
          link :key="i"
        >
          

          <v-list-item-content>
            <v-list-item-title> {{ $t(menu.name) }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon class="mx-2">
            <v-icon v-text="menu.icon">close</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-item-group>
      
     
         <v-list-item
          link @click="handleLogout"
        >
         
          <v-list-item-content>
            <v-list-item-title v-text="$t('Menu.logout')"></v-list-item-title>
          </v-list-item-content>
           <v-list-item-icon class="mx-2">
            <v-icon>logout</v-icon>
          </v-list-item-icon>

        </v-list-item>
    </v-list>
<v-bottom-navigation flat grow v-else
    v-model="type" color="primary lighten-2"
    
    fixed style="z-index:11" :height="platform=='ios' ? 70 : 54"
  >
    <v-btn  v-if="courier" :class="{'pb-4': platform=='ios'}">
      <span>Ophalen</span>
    <v-badge
              color="red"
              :value="fetchCount > 0"
              :content="fetchCount"
              class="mr-5"
            >
      <v-icon >mdi-bike-fast</v-icon>
      </v-badge>
    </v-btn>
    <v-btn :class="{'pb-4': platform=='ios'}">
      <span v-text="$t('Common.orderfood')"></span>

      <v-icon >restaurant</v-icon>
    </v-btn>
<v-btn v-if="false" :class="{'pb-4': platform=='ios'}">
      <span v-text="$t('Common.deliver')"></span>

      <v-icon >delivery_dining</v-icon>
    </v-btn>
    <!--v-btn value="takeaway" @click="setConfig({'tabs': 0})">
      <span v-text="$t('Common.takeaway')"></span>

      <v-icon >store</v-icon>
    </v-btn-->
  
    <v-btn :class="{'pb-4': platform=='ios'}">
      <span v-text="$t('Common.stamps')"></span>

      <v-icon >savings</v-icon>

    </v-btn>
<v-btn  @click="setConfig({'tabs': 2})" :class="{'pb-4': platform=='ios'}">
      <span v-text="$t('Common.orders')"></span>
<v-badge
              color="red"
              :value="orderCount > 0"
              :content="orderCount"
              class="mr-5"
            >
      <v-icon >list</v-icon>
</v-badge>
    </v-btn>
    <v-btn  v-show="type==(courier ? 4 : 3)" :class="{'pb-4': platform=='ios'}">
      <span>Vereniging</span>

      <v-icon >hub</v-icon>
    </v-btn>
   
    <!--v-btn  value="reservation" @click="setConfig({'tabs': 0})">
      <span v-text="$t('Common.reservation')"></span>

      <v-icon >mdi-table-chair</v-icon>
    </v-btn-->
  </v-bottom-navigation>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: ['value','clubs','stamps','orders','deliveries'],
  data () {
    return {
     
    }
    },
 computed: {
   ...mapGetters([
      'user','address','courier'
    ]),
    menus(){
      let m =  [
          {name: 'Common.orderfood', icon: 'restaurant'},
           {name: 'Common.stamps', icon: 'savings'},
            {name: 'Common.orders', icon: 'list'},
             {name: 'Common.clublist', icon: 'hub'}
             
        ]
        if (this.courier) m.unshift( {name: 'Common.fetchlist', icon: 'mdi-bike-fast'})
      return m
      },
    type: {
      get() {
        return this.value
      },
      set(value){
        this.$emit('input',value)
      }
    },
    orderCount(){
      return this.orders.filter(o=>this.$moment().isSame(o.date, 'day')).length
    },
    fetchCount(){
      return this.deliveries.length
    }
  },
 methods: {
    ...mapActions([
      'setConfig','logout'
    ]),
    allowNotify(){
      Notification.requestPermission().then((result) => {
        if (result === 'granted') {
          this.randomNotification();
        }
      });
    },
    randomNotification() {
      const notifTitle = 'Eetplein.nl';
      const notifBody = `Created by Me.`;
      const notifImg = `logo.png`;
      const options = {
        body: notifBody,
        icon: notifImg,
      };
      new Notification(notifTitle, options);
      //setTimeout(this.randomNotification, 30000);
    },
    handleLogout(){
      this.logout()
      this.$router.push('/')
    },

 }
}

</script>

